export class CustomerAddress {
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  phoneNumber?: string;

  constructor(data: Object = {}) {
    Object.assign(this, data);
  }
}

export class CustomerModel {
  customerId: number;
  address?: CustomerAddress;
  affiliateCampaignCode?: string;
  affiliateId?: number;
  allowPromoEmails?: boolean;
  allowPromoSms?: boolean;
  allowPromoPost?: boolean;
  americanCitizen?: boolean;
  avatarId?: number;
  birthDate?: Date;
  campaignCode?: string;
  certOver18?: boolean;
  createdDate?: Date;
  currentLoginTime?: Date;
  customData: [
    {
      key?: string;
      value?: string;
    }
  ];
  customerAttributionData?: string;
  email?: string;
  excludedUntilTs?: Date;
  extAffiliateCampaignId?: string;
  extAffiliateId?: string;
  extCustId?: string;
  facebookId?: string;
  failedPasswordCount?: number;
  firstName?: string;
  gender?: string;
  governmentId?: string;
  governmentIDs: [
    {
      key?: string;
      value?: string;
    }
  ];
  governmentTypeId?: string;
  lastLoginTime?: Date;
  lastName?: string;
  middleName?: string;
  nickName?: string;
  password?: string;
  pinNumber?: string;
  preferredCurrency?: {
    currencyCode?: string;
  };
  preferredEmailFormat?: string;
  preferredLanguage?: string;
  privacyPolicy?: boolean;
  salutation?: string;
  sendEmailUponLogin?: boolean;
  status?: string;
  securityQuestion?: string;
  securityAnswer?: string;
  secondSecurityQuestion?: string;
  secondSecurityAnswer?: string;
  surveys?: boolean;
  skinId?: number;
  termsAndCondVersion?: string;
  testAccount?: boolean;
  identityVerificationMethod?: string;
  isBeginnger?: boolean;
  userName?: string;
  emailValidated?: boolean;
  kycValidated?: boolean;
  citizenship?:string;
  kyc_attempts?: number;
  jobTitle?:string;
  jobIndustry?:string;
  employerName?:string;
  employerAddress?:string;
  businessPhoneNumber?:string;

  constructor(data: any = {}) {
    this.address = new CustomerAddress(data.address);
    Object.assign(this, data);
  }

  isActive() {
    return this.status.toUpperCase() == 'ACTIVE';
  }

  isIncomplete() {
    if (
      typeof this.firstName == 'undefined' ||
      typeof this.lastName == 'undefined'
    ) {
      return true;
    }
    if (this.status.toUpperCase() == 'INCOMPLETE') {
      return true;
    }
    return false;
  }

  isKycValidated() {
    return typeof this.kycValidated == 'undefined' || !this.kycValidated
      ? false
      : true;
  }

  getCustomDataProperty(key) {
    let value = null;
    if (this.customData) {
      this.customData.forEach(function (item) {
        if (item.key == key) {
          value = item.value;
        }
      });
    }
    return value;
  }
}

export enum eCustomerStatus {
  "ACTIVE" = "ACTIVE",
  "SELF_EXCLUDED_COOL_OFF" = "SELF_EXCLUDED_COOL_OFF",
  "kyc_fail" = "kyc_fail",
  "incomplete" = "incomplete",
}

export enum eIdentityVerificationMethod {
  KYC = "KYC",
}

export interface ICustomerPayload {
  customerId: number;
  address: CustomerAddress;
  email: string;
  firstName: string;
  lastName: string;
  userName: string;
  birthDate: Date|string;
  skinId: number;
  allowPromoEmails: true;
  allowPromoSms: false;
  preferredCurrency: {
    currencyCode: string;
  };
  preferredLanguage: {
    languageCode: string;
  };
  avatarId: number;
  securityQuestion: string;
  createdDate: string;
  lastLoginTime: string;
  preferredEmailFormat: string;
  extCustId: string;
  status: eCustomerStatus;
  surveys: boolean;
  certOver18: boolean;
  privacyPolicy: boolean;
  customData: {
    key: string;
    value: string;
  }[];
  governmentId: string;
  governmentTypeId: string;
  failedPasswordCount: number;
  secondSecurityQuestion: string;
  termsAndCondVersion: string;
  termsAndCondTs: Date|string;
  americanCitizen: boolean;
  sendEmailUponLogin: boolean;
  identityVerificationMethod: eIdentityVerificationMethod;
  testAccount: boolean;
  isBeginner: boolean;
  currentLoginTime: Date|string;
  docsVerified: boolean;
  emailValidated: boolean;
  kycValidated: boolean;
  ackRegulations: boolean;
  currentLoginTimeStamp: Date|string;
  kyc_attempts: number;
}
